import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IBanner } from '@core/interfaces/ibanner';
import { DataService } from './data.service';


@Injectable({ providedIn: 'root' })
export class BannerService {
  dataService = inject(DataService);

  getBanner(): Observable<IBanner> {
    return this.dataService.get('admin/get-banner');
  }

  saveBanner(banner: IBanner): Observable<IBanner> {
    return this.dataService.post(`admin/add-banner`, banner); 
  }
}
